import React from 'react';
import {
    FaHeadset, FaShieldHalved, FaCalculator, FaMoneyBillWave, FaReceipt, FaPhone, FaUsers, FaCirclePlus,
} from 'react-icons/fa6';
import simplia from '../../../../img/simplia.png';

/** Pestañas del detalle de cobranza (mockup "ModuleNavigationTabs"), modo claro y oscuro. */
export const TabNavigation = ({ activeTab, setActiveTab, setSelectedId, data, totalGestiones }) => {
    const tabs = [
        { id: 'GESTION', name: 'Gestión', icon: FaHeadset, contador: totalGestiones },
        { id: 'VERIFICACION', name: 'Verificación', icon: FaShieldHalved },
        { id: 'TABLA DE AMORTIZACION', name: 'Amortización', icon: FaCalculator },
        { id: 'PAGOS', name: 'Pagos', icon: FaMoneyBillWave },
        { id: 'FACTURA', name: 'Factura', icon: FaReceipt },
        { id: 'TELEFONOS', name: 'Teléfonos', icon: FaPhone },
        { id: 'REFERENCIAS', name: 'Referencias', icon: FaUsers },
    ];

    return (
        <div className="px-4 sm:px-6 pt-4 shrink-0 z-10 relative">
            <nav aria-label="Pestañas"
                className="bg-white dark:bg-[#111827] rounded-xl border border-slate-200 dark:border-slate-800 shadow-sm p-1.5 flex flex-wrap items-center justify-between gap-2">
                <div className="flex items-center gap-1 overflow-x-auto w-full md:w-auto">
                    {tabs.map((tab) => {
                        const activo = activeTab === tab.id;
                        const Icono = tab.icon;
                        return (
                            <button
                                key={tab.id}
                                type="button"
                                onClick={() => setActiveTab(tab.id)}
                                className={`inline-flex items-center gap-2 px-3.5 py-1.5 text-xs rounded-lg transition whitespace-nowrap ${activo
                                    ? 'font-bold bg-indigo-600 text-white shadow-sm'
                                    : 'font-medium text-slate-600 hover:text-slate-900 hover:bg-slate-100 dark:text-slate-300 dark:hover:text-white dark:hover:bg-slate-800'}`}
                            >
                                <Icono className={`text-xs ${activo ? '' : 'text-slate-400'}`} />
                                <span>{tab.name}</span>
                                {tab.contador > 0 && (
                                    <span className={`ml-1 px-1.5 text-[10px] rounded-full ${activo ? 'bg-white/20 text-white' : 'bg-slate-200 text-slate-600 dark:bg-slate-700 dark:text-slate-200'}`}>
                                        {tab.contador}
                                    </span>
                                )}
                            </button>
                        );
                    })}
                </div>
                <div className="flex items-center gap-2 md:pl-2 pt-2 md:pt-0 border-t md:border-t-0 md:border-l border-slate-200 dark:border-slate-800 w-full md:w-auto">
                    <button
                        type="button"
                        onClick={() => setActiveTab('SAVE_GESTION')}
                        className={`inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-lg border transition ${activeTab === 'SAVE_GESTION'
                            ? 'bg-indigo-600 text-white border-indigo-600'
                            : 'border-indigo-200 bg-indigo-50 text-indigo-700 hover:bg-indigo-100 dark:border-indigo-700/50 dark:bg-indigo-950/60 dark:text-indigo-300 dark:hover:bg-indigo-900/60'}`}
                    >
                        <FaCirclePlus className="text-xs" />
                        <span>Ingresar Gestión</span>
                    </button>
                    <button
                        type="button"
                        onClick={() => { setSelectedId(data?.idCompra); setActiveTab('SIMPLIA'); }}
                        title="Simplia"
                        className={`inline-flex items-center px-2.5 py-1 rounded-md bg-blue-600 hover:bg-blue-500 transition ${activeTab === 'SIMPLIA' ? 'ring-2 ring-offset-2 ring-blue-400 ring-offset-white dark:ring-offset-[#111827]' : ''}`}
                    >
                        <img src={simplia} alt="Simplia" className="h-4 object-contain brightness-0 invert" />
                    </button>
                </div>
            </nav>
        </div>
    );
};
